import React from "react";
import "./RelatedArticles.css";
import RelatedArticleCard from "./RelatedArticleCard";

export default function RelatedArticles({ articles }) {
  if (!articles || articles.length === 0) return null;

  return (
    <div style={{ width: "100%", marginTop: 24 }}>
      <h2 style={{ fontSize: 18, margin: "0 0 12px 0", color: "#222222" }}>
        Dans la même catégorie
      </h2>
      <div className={"related-articles-rail"}>
        {articles.map((article) => (
          <RelatedArticleCard article={article} key={"related_" + article.id} />
        ))}
      </div>
    </div>
  );
}
